/**
 * A global namespace for `touchend` event.
 */
const touchendEvent = "touchend";
export default touchendEvent;
